export const REDIRECT_TO_APPS_PARAM_NAME = 'redirect_to';
